export const chat = {
    zendesk: 'zendesk',
    sprinklr: 'sprinklr',
    none: 'none',
};
export const BAA = {
    REASONS: {
        PERSONALIZATION: 552250004,
        DISCOVERCOLLECTION: 552250000,
    },
    APPOINTMENT: {
        INSTORE: 552250000,
        VIRTUAL: 552250001,
        CARAVAN: 552250002,
    },
    TREBASELEGHE: {
        SELF: 'myself',
        GUEST: 'guest',
    },
};
export const menu = {
    overlay: {
        timeout: 200,
    },
};
export const freeExpressShippingCustomerGroup = 'FreeExpressShippingForNewMembers';
export const contactFormId = 'contact-form';
